const questionTypes = {
  FEEDBACK: 0,
  OPINION_SCALE: 1,
  TEXT_RESPONSE: 2,
  MULTIPLE_CHOICE: 3,
  getQuestionTypeIcon: id => {
    switch (id) {
      case questionTypes.OPINION_SCALE:
        return "straighten";
      case questionTypes.TEXT_RESPONSE:
        return "chat";
      case questionTypes.MULTIPLE_CHOICE:
        return "done_all";
    }
    return "";
  },
  getQuestionTypeColor: id => {
    switch (id) {
      case questionTypes.OPINION_SCALE:
        return "#F6CC5B";
      case questionTypes.TEXT_RESPONSE:
        return "#ED9671";
      case questionTypes.MULTIPLE_CHOICE:
        return "#66A9DC";
    }
    return "";
  },
  getOpinionScoreColor: i => {
    let score = i - 1;
    if (score >= 8) {
      return this.$vuetify.theme.themes.light.success;
    } else if (score >= 6) {
      return this.$vuetify.theme.themes.light.info;
    } else if (score >= 4) {
      return this.$vuetify.theme.themes.light.lightwarning;
    } else if (score >= 2) {
      return this.$vuetify.theme.themes.light.warning;
    }
    return this.$vuetify.theme.themes.light.error;
  }
};

export default questionTypes;
